import React from "react";
import Card from "./Card";

interface StatCardProps {
    label: string;
    value: string;
    change?: string;
}

const StatCard: React.FC<StatCardProps> = ({ label, value, change }) => {
    return (
        <Card className="stat-card">
            <span className="stat-label">{label}</span>
            <strong className="stat-value">{value}</strong>
            {change ? <span className="stat-change">{change}</span> : null}
        </Card>
    );
};

export default StatCard;
